import { SvgIcon } from "@material-ui/core";

export const PasswordIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_813_555)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.0200195 2.99172C0.0200195 1.33944 1.36048 0 3.01403 0H16.9861C18.6397 0 19.9801 1.33945 19.9801 2.99172V5.48482C19.9801 6.03558 19.5333 6.48206 18.9821 6.48206C18.4309 6.48206 17.9841 6.03558 17.9841 5.48482V2.99172C17.9841 2.44095 17.5373 1.99448 16.9861 1.99448H3.01403C2.46285 1.99448 2.01603 2.44096 2.01603 2.99172V7.97791C2.01603 8.5287 2.46284 8.97515 3.01403 8.97515H8.87731C9.42849 8.97515 9.87531 9.42163 9.87531 9.97239C9.87531 10.5232 9.42849 10.9696 8.87731 10.9696H3.01403C1.36049 10.9696 0.0200195 9.63024 0.0200195 7.97791V2.99172ZM11.9961 8.97515C11.9961 7.32284 13.3365 5.98344 14.9901 5.98344C16.6437 5.98344 17.9841 7.32284 17.9841 8.97515V9.97239C19.0865 9.97239 19.9801 10.8653 19.9801 11.9669V15.9558C19.9801 17.0574 19.0865 17.9503 17.9841 17.9503H11.9961C10.8937 17.9503 10.0001 17.0574 10.0001 15.9558V11.9669C10.0001 10.8653 10.8937 9.97239 11.9961 9.97239V8.97515ZM11.9961 11.9669V15.9558H17.9841V11.9669H11.9961ZM15.9881 9.97239H13.9921V8.97515C13.9921 8.42436 14.4389 7.97791 14.9901 7.97791C15.5413 7.97791 15.9881 8.42436 15.9881 8.97515V9.97239ZM17.9853 15.9558L17.9853 15.9558L17.9853 15.9558Z"
            fill="#868E96"
          />
          <path
            d="M5.50897 6.98049C6.33574 6.98049 7.00597 6.31077 7.00597 5.48463C7.00597 4.65849 6.33574 3.98877 5.50897 3.98877C4.6822 3.98877 4.01196 4.65849 4.01196 5.48463C4.01196 6.31077 4.6822 6.98049 5.50897 6.98049Z"
            fill="#868E96"
          />
          <path
            d="M9.99999 6.98049C10.8268 6.98049 11.497 6.31077 11.497 5.48463C11.497 4.65849 10.8268 3.98877 9.99999 3.98877C9.17321 3.98877 8.50298 4.65849 8.50298 5.48463C8.50298 6.31077 9.17321 6.98049 9.99999 6.98049Z"
            fill="#868E96"
          />
        </g>
        <defs>
          <clipPath id="clip0_813_555">
            <rect width="20" height="17.9503" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
};

export const PasswordActiveIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="20"
        height="18"
        viewBox="0 0 20 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_813_558)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.0200195 2.99172C0.0200195 1.33944 1.36048 0 3.01403 0H16.9861C18.6397 0 19.9801 1.33945 19.9801 2.99172V5.48482C19.9801 6.03558 19.5333 6.48206 18.9821 6.48206C18.4309 6.48206 17.9841 6.03558 17.9841 5.48482V2.99172C17.9841 2.44095 17.5373 1.99448 16.9861 1.99448H3.01403C2.46285 1.99448 2.01603 2.44096 2.01603 2.99172V7.97791C2.01603 8.5287 2.46284 8.97515 3.01403 8.97515H8.87731C9.42849 8.97515 9.87531 9.42163 9.87531 9.97239C9.87531 10.5232 9.42849 10.9696 8.87731 10.9696H3.01403C1.36049 10.9696 0.0200195 9.63024 0.0200195 7.97791V2.99172ZM11.9961 8.97515C11.9961 7.32284 13.3365 5.98344 14.9901 5.98344C16.6437 5.98344 17.9841 7.32284 17.9841 8.97515V9.97239C19.0865 9.97239 19.9801 10.8653 19.9801 11.9669V15.9558C19.9801 17.0574 19.0865 17.9503 17.9841 17.9503H11.9961C10.8937 17.9503 10.0001 17.0574 10.0001 15.9558V11.9669C10.0001 10.8653 10.8937 9.97239 11.9961 9.97239V8.97515ZM11.9961 11.9669V15.9558H17.9841V11.9669H11.9961ZM15.9881 9.97239H13.9921V8.97515C13.9921 8.42436 14.4389 7.97791 14.9901 7.97791C15.5413 7.97791 15.9881 8.42436 15.9881 8.97515V9.97239ZM17.9853 15.9558L17.9853 15.9558L17.9853 15.9558Z"
            fill="#343A40"
          />
          <path
            d="M5.50921 6.98049C6.33599 6.98049 7.00622 6.31077 7.00622 5.48463C7.00622 4.65849 6.33599 3.98877 5.50921 3.98877C4.68244 3.98877 4.01221 4.65849 4.01221 5.48463C4.01221 6.31077 4.68244 6.98049 5.50921 6.98049Z"
            fill="#343A40"
          />
          <path
            d="M10.0002 6.98049C10.827 6.98049 11.4972 6.31077 11.4972 5.48463C11.4972 4.65849 10.827 3.98877 10.0002 3.98877C9.17346 3.98877 8.50322 4.65849 8.50322 5.48463C8.50322 6.31077 9.17346 6.98049 10.0002 6.98049Z"
            fill="#343A40"
          />
        </g>
        <defs>
          <clipPath id="clip0_813_558">
            <rect width="20" height="17.9503" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
};

export const ShowPasswordIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="22"
        height="16"
        viewBox="0 0 22 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.61427 2.34904C6.51776 0.969031 8.78347 0 11.0007 0C13.218 0 15.4834 0.969319 17.3866 2.34948C19.2934 3.7323 20.9381 5.59961 21.8939 7.55142C21.9028 7.56912 21.9112 7.58708 21.919 7.60525C21.9744 7.73397 22.0007 7.86855 22.0005 8.00124C22.0004 8.13326 21.9741 8.2671 21.919 8.39515C21.9111 8.4134 21.9027 8.43143 21.8938 8.44921C20.9379 10.401 19.2931 12.2681 17.3862 13.6508C15.4828 15.0308 13.2173 16 11 16C8.78273 16 6.51717 15.0308 4.61385 13.6507C2.70689 12.2679 1.06215 10.4006 0.106462 8.44845C0.0978597 8.43128 0.0897558 8.41388 0.082159 8.39626C0.0259763 8.26644 -0.000498647 8.13063 7.10807e-06 7.99677C0.000310089 7.86535 0.0266339 7.73216 0.0815622 7.60472C0.0893625 7.58656 0.0977011 7.56862 0.10657 7.55093C1.0623 5.59881 2.7072 3.73164 4.61427 2.34904ZM16.2125 3.96856C17.744 5.07922 19.0524 6.52747 19.8723 8.00019C19.0524 9.47284 17.7439 10.921 16.2122 12.0316C14.5216 13.2574 12.6605 14 11 14C9.33955 14 7.47844 13.2574 5.78791 12.0316C4.25622 10.9209 2.94775 9.47262 2.12809 7.9998C2.94775 6.52702 4.25634 5.07884 5.78819 3.96827C7.47888 2.74254 9.3402 2 11.0007 2C12.6611 2 14.522 2.74267 16.2125 3.96856ZM9.00023 7.99999C9.00023 6.89538 9.89562 5.99999 11.0002 5.99999C12.1048 5.99999 13.0002 6.89538 13.0002 7.99999C13.0002 9.10461 12.1048 10 11.0002 10C9.89562 10 9.00023 9.10461 9.00023 7.99999ZM11.0002 3.99999C8.79105 3.99999 7.00023 5.79081 7.00023 7.99999C7.00023 10.2092 8.79105 12 11.0002 12C13.2094 12 15.0002 10.2092 15.0002 7.99999C15.0002 5.79081 13.2094 3.99999 11.0002 3.99999Z"
          fill="#868E96"
        />
      </svg>
    </SvgIcon>
  );
};

export const HidePasswordIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="22"
        height="12"
        viewBox="0 0 22 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.11148 0.106491C1.63138 -0.147403 2.25867 0.0682402 2.51256 0.588144C2.91913 1.42067 3.41443 2.18341 3.9826 2.8615C4.01178 2.89206 4.03876 2.92394 4.06353 2.95695C4.89253 3.923 5.87144 4.71166 6.9527 5.27843C6.98133 5.28977 7.00972 5.30246 7.03777 5.31653C7.0703 5.33285 7.1016 5.35062 7.13165 5.36974C8.32303 5.96118 9.63306 6.28577 11.0001 6.28577C12.3669 6.28577 13.6767 5.96125 14.868 5.36996C14.8982 5.35076 14.9296 5.33291 14.9622 5.31654C14.9904 5.3024 15.019 5.28965 15.0478 5.27826C16.1277 4.71216 17.1055 3.92474 17.9339 2.96035C17.9603 2.92496 17.9891 2.89086 18.0205 2.85828C18.5876 2.18108 19.082 1.41957 19.488 0.588516C19.742 0.068653 20.3693 -0.146889 20.8892 0.107089C21.409 0.361067 21.6246 0.98839 21.3706 1.50825C21.0266 2.21232 20.6254 2.87948 20.1733 3.50125L21.6932 5.02119C22.1023 5.43033 22.1023 6.09365 21.6931 6.50276C21.284 6.91187 20.6207 6.91186 20.2116 6.50272L18.8031 5.09418C18.1945 5.69291 17.529 6.22408 16.8159 6.67554L17.6984 8.43515C17.9578 8.95233 17.7488 9.58187 17.2317 9.84127C16.7145 10.1007 16.0849 9.89169 15.8255 9.37451L14.9492 7.62721C14.0315 7.99042 13.0594 8.23115 12.0477 8.33007V10.4763C12.0477 11.0549 11.5786 11.5239 11.0001 11.5239C10.4215 11.5239 9.95243 11.0549 9.95243 10.4763V8.33007C8.94073 8.23115 7.9686 7.99041 7.05089 7.6272L6.17457 9.37449C5.91518 9.89168 5.28565 10.1007 4.76846 9.84128C4.25127 9.58189 4.04229 8.95236 4.30167 8.43517L5.18421 6.67549C4.4711 6.224 3.80561 5.6928 3.19707 5.09403L1.78842 6.50273C1.37931 6.91186 0.715987 6.91187 0.306856 6.50276C-0.102274 6.09364 -0.102287 5.43032 0.306828 5.02119L1.82699 3.50097C1.37496 2.87909 0.973732 2.2118 0.629825 1.50758C0.375931 0.987673 0.591574 0.360386 1.11148 0.106491Z"
          fill="#868E96"
        />
      </svg>
    </SvgIcon>
  );
};

export const CheckIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="41"
        height="41"
        viewBox="0 0 41 41"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.800781 20.6855C0.800781 9.70295 9.70392 0.799805 20.6865 0.799805C23.8576 0.799805 26.8607 1.54356 29.5257 2.86792C30.5092 3.35666 30.9103 4.55016 30.4216 5.53368C29.9328 6.51719 28.7393 6.91828 27.7558 6.42953C25.6284 5.37233 23.2298 4.77695 20.6865 4.77695C11.9004 4.77695 4.77792 11.8995 4.77792 20.6855C4.77792 29.4716 11.9004 36.5941 20.6865 36.5941C29.4726 36.5941 36.5951 29.4717 36.5951 20.6855C36.5951 20.0864 36.5621 19.4957 36.4979 18.9155C36.3772 17.8239 37.1643 16.8411 38.2559 16.7204C39.3475 16.5997 40.3303 17.3868 40.451 18.4784C40.5312 19.2038 40.5722 19.9404 40.5722 20.6855C40.5722 31.6682 31.6691 40.5712 20.6865 40.5712C9.70393 40.5712 0.800781 31.6682 0.800781 20.6855ZM39.9898 5.35939C40.7664 6.13597 40.7664 7.39507 39.9898 8.17165L22.0926 26.0688C21.316 26.8454 20.0569 26.8454 19.2804 26.0688L13.3146 20.1031C12.5381 19.3265 12.5381 18.0674 13.3146 17.2908C14.0912 16.5142 15.3503 16.5142 16.1269 17.2908L20.6865 21.8504L37.1775 5.35939C37.9541 4.5828 39.2132 4.5828 39.9898 5.35939Z"
          fill="#40C057"
        />
      </svg>
    </SvgIcon>
  );
};
